module.exports = __webpack_public_path__ + "img/iglu-on.a2323887.png";